import React from "react";
import { withTranslation } from "react-i18next";
import { connect } from "react-redux";
import { CMSPath } from "../../../config/constant";
import { getDefaultAnalyticsLabel } from "../../JS/utility";
import { sendAnalytics } from "../../../action/homeAction";


const SpaBooking1 = (props) => {

	const { t } = props
	let label = getDefaultAnalyticsLabel({ appVersion: props.installedAppVersion ? `${props.installedAppVersion}(${props.installedAppBuildNo})` : "" })
	let widgetSesstionId = localStorage.getItem("spaBookingSessionToken");

	let imagePath;

	const handleNext = (locationID) => {
		props.next(locationID.spalocationId)
	}

	React.useEffect(() => {
		if (props.spaData.length == 1) {
			handleNext(props.spaData[0])
		}
	}, [])

	return (
		<section class="widgets spa-listing">

			<div class="widget-header">

				{props.currentWidgetObj.widgetHeaderImageUrl &&
					<div class="widget-header-img">
						<img src={`${CMSPath}${props.currentWidgetObj.widgetHeaderImageUrl}`} alt={props.currentWidgetObj.displayName} />
					</div>
				}

				<div class="widget-header-title">{t(`spaBooking.heading`)}</div>
			</div>

			<div class="row">
				<div class="col sm-banner">
					<div class="col sm-banner">
						{props.spaData.map((iterator) => {

							imagePath = iterator.imageName ? encodeURI(`${CMSPath}${iterator.imageName}`) : "";

							return (
								<a id={iterator.widgetType} className={'tile-sm thumbnails tile-container'}
									onClick={() => { handleNext(iterator) }}
								>
									<div class="thumb-img">
										{imagePath ?
											<img src={imagePath}></img> :
											""
										}
									</div>

									<div class="thumb-text">
										<p class="thumb-heading">{iterator.spaLocationName}</p>
										<p>{iterator.spaDescription}</p>
									</div>
								</a>
							)
						})
						}
					</div>
				</div>
			</div>
		</section>
	)

}

const mapStateToProps = state => {
	return {
		installedAppVersion: state.store.installedAppVersion,
		installedAppBuildNo: state.store.installedAppBuildNo,
		currentHomePage: state.store2.currentHomePage,
		currentWidgetObj: state.store.sideNavBar.currentWidget,
		guestDetail: state.store.home.guestDetails,
		guestIsLoggedIn: state.store2.guestIsLoggedIn,
		currentWidgets: state.store.sideNavBar.currentWidget,
	}
}

export default connect(mapStateToProps, { sendAnalytics })(withTranslation('translations')(SpaBooking1));